import { InsightData } from 'schemas/action/InsightDataSchema'
import { Filter } from 'schemas/FilterSchema'
import { SearchFilterComposingStrategy } from './searchFilterComposingStrategy'

const composeDetailSearchFilter = (filter: Filter, insights: InsightData[]) => ({
  ...filter,
  hashTags: [
    ...(filter.hashTags || []),
    Array.from(insights).map((insight) => insight.name!.replace('#', ''))
  ]
})

const generateHashtagsInsightStrategy = (): SearchFilterComposingStrategy => ({
  composeDetailSearchFilter
})

export default generateHashtagsInsightStrategy
